import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectSound extends PageObject {
  sound: string;
  image: string;

  constructor(obj: PageObjectSound = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Sound;

    if (obj == null) {
      this.sound = "";
      this.image = "";
    } else {
      this.sound = obj.sound;
      this.image = obj.image;
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    list.push(new ObjectProperty("Sound", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Image", OBJECTPROPERTYTYPE.Text));

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Sound") {
      return this.sound;
    } else if (name == "Image") {
      return this.image;
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Sound") {
      this.sound = value;
    } else if (name == "Image") {
      this.image = value;
    }
  }
}
